module.exports = __webpack_public_path__ + "static/media/woman-chair.fafab27f.jpg";